<template>
  <div
    class="flex items-center justify-center promo-block"
    style="height: 50px;"
  >
    <i class="text-white fa-solid fa-gift" />
      <div
        class="ml-3 text-sm text-white uppercase font-bold"
      >
        January Sale!
      </div>
      <div class="ml-3 text-sm text-white uppercase flex items-center">
        Kick off 2023 with a bang and &nbsp;<span class="font-bold"> save $50 today.</span>&nbsp;Offer ends soon!
      </div>
      <a
      href="/pricing/"
      class="bg-white inline-flex items-center px-5 ml-3 border border-white rounded-full"
      style="height: 28px;"
    >
      <span
        class="text-xs font-bold text-white text-[#20458D]"
      >
        {{ cta }}
      </span>
    </a>
  </div>
</template>

<script>
export default {
  computed: {
    cta() {
      if (['free', 'visitor'].includes(this.$store.getters.userType)) {
        return 'Save Now';
      }
      return 'Upgrade Now';
    },
  },
};
</script>

<style scoped>
.promo-block {
  background: url('/assets/images/site/home/bg-holiday.jpg');
  background-repeat: no-repeat;
  background-size: auto;
}
.text-\[\#20458D\] {
  color: #20458D;
}
</style>
